<script setup lang="ts">
import PdsAvatar from '@/components/pds/PdsAvatar.vue';
import PdsButton from '@/components/pds/PdsButton.vue';
import { useAuthStore } from '@/stores/auth/auth.slice';
import { useOperator } from '../composables/useOperator';
import { formatTime } from '../format';
import { usePdsOrdersStore } from '../stores/orders.store';

const authStore = useAuthStore();
const orders = usePdsOrdersStore();
const { name, initials, role, store } = useOperator();
</script>

<template>
  <main
    class="no-scrollbar flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto px-4 py-5 sm:px-5"
  >
    <div class="flex w-[600px] max-w-full flex-col gap-4">
      <section
        class="bg-accent text-accent-encre flex flex-col gap-6 rounded-[24px] p-6"
      >
        <div class="flex items-baseline gap-3">
          <p
            class="text-[12px] leading-[1.2] font-semibold tracking-[0.9px] uppercase opacity-70"
          >
            {{ ['Poste', store].filter(Boolean).join(' · ') }}
          </p>
          <span class="ml-auto text-[14px] leading-5">
            {{ formatTime(orders.now) }}
          </span>
        </div>
        <div class="flex items-center gap-[18px]">
          <PdsAvatar :initials="initials" size="lg" pressed />
          <div class="flex min-w-0 flex-col gap-[6px]">
            <p
              class="truncate text-[32px] leading-8 font-bold tracking-[-0.4px]"
            >
              {{ name }}
            </p>
            <p class="flex items-center gap-2 text-[18px] leading-[1.2]">
              <i class="bg-succes size-[10px] shrink-0 rounded-full"></i>
              {{ ['Connecté', role].filter(Boolean).join(' · ') }}
            </p>
          </div>
        </div>
        <button
          type="button"
          class="bg-primaire-sur-accent text-primaire-sur-accent-encre h-[62px] w-full cursor-pointer rounded-[12px] px-5 text-[14px] leading-[1.4] font-semibold active:brightness-95"
          @click="authStore.logout()"
        >
          Passer la main
        </button>
      </section>
      <PdsButton variant="second" to="/">Rester connecté</PdsButton>
    </div>
  </main>
</template>
